// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '1.2.8';
export const APP_NAME = 'bus-italia-portale-rendicontazione';
export const FILE_HASH = '1777303292122';
export const BUILD_DATE = '2026-04-27T15:21:32.122Z';
/* tslint:enable */
